import * as types from '@/store/mutation-types'

const getters = {
  showTopLoading: state => state.showTopLoading,
  showBtnLoading: state => state.showBtnLoading,
  showCenterLoading: state => state.showCenterLoading
}

const mutations = {
  [types.SHOW_TOP_LOADING](state, value) {
    state.showTopLoading = value
  },
  [types.SHOW_BTN_LOADING](state, value) {
    state.showBtnLoading = value
  },
  [types.SHOW_CENTER_LOADING](state, value) {
    state.showCenterLoading = value
  }
}

const state = {
  showTopLoading: false,
  showBtnLoading: false,
  showCenterLoading: false
}

export default {
  state,
  getters,
  mutations
}
